import { useState } from 'react'
import { Search, Plus, Pencil, Trash2, Users, UserCheck, UserX, Clock } from 'lucide-react'
import { Modal, ConfirmModal } from '../common/Modal'

const USERS = [
  { id:'USR-001', name:'Sarah Mitchell',  email:'sarah@acme.com',   role:'Admin',  plan:'Enterprise', status:'active',   joined:'Jan 12, 2025' },
  { id:'USR-002', name:'James Holloway',  email:'james@corp.io',    role:'Manager',plan:'Pro',        status:'active',   joined:'Feb 4, 2025' },
  { id:'USR-003', name:'Priya Sharma',    email:'priya@start.co',   role:'User',   plan:'Starter',    status:'active',   joined:'Mar 8, 2025' },
  { id:'USR-004', name:'Luca Martini',    email:'luca@design.eu',   role:'User',   plan:'Enterprise', status:'inactive', joined:'Mar 15, 2025' },
  { id:'USR-005', name:'Emily Chen',      email:'emily@techco.com', role:'Manager',plan:'Pro',        status:'active',   joined:'Apr 1, 2025' },
  { id:'USR-006', name:'Daniel Okafor',   email:'daniel@ng.dev',    role:'User',   plan:'Free',       status:'active',   joined:'Apr 18, 2025' },
  { id:'USR-007', name:'Anika Patel',     email:'anika@health.in',  role:'User',   plan:'Starter',    status:'pending',  joined:'May 2, 2025' },
]

export default function User() {
  const [users, setUsers] = useState(USERS)
  const [search, setSearch] = useState('')
  const [modalOpen, setModalOpen] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)
  const [active, setActive] = useState(null)
  const [form, setForm] = useState({ name: '', email: '', role: 'User', plan: 'Starter', status: 'active' })

  const filtered = users.filter(u =>
    u.name.toLowerCase().includes(search.toLowerCase()) ||
    u.email.toLowerCase().includes(search.toLowerCase())
  )

  const openAdd = () => {
    setActive(null)
    setForm({ name: '', email: '', role: 'User', plan: 'Starter', status: 'active' })
    setModalOpen(true)
  }

  const openEdit = (user) => {
    setActive(user)
    setForm({ name: user.name, email: user.email, role: user.role, plan: user.plan, status: user.status })
    setModalOpen(true)
  }

  const saveUser = () => {
    if (!form.name.trim() || !form.email.trim()) return
    if (active) {
      setUsers(prev => prev.map(u => u.id === active.id ? { ...u, ...form } : u))
    } else {
      const next = `USR-${String(users.length + 1).padStart(3, '0')}`
      setUsers(prev => [{ id: next, joined: 'Today', ...form }, ...prev])
    }
    setModalOpen(false)
  }

  const confirmDelete = () => {
    setUsers(prev => prev.filter(u => u.id !== active.id))
    setDeleteOpen(false)
    setActive(null)
  }

  const activeCount   = users.filter(u => u.status === 'active').length
  const inactiveCount = users.filter(u => u.status === 'inactive').length
  const pendingCount  = users.filter(u => u.status === 'pending').length

  const stats = [
    { label: 'Total Users',  value: users.length,  icon: Users,     color: '#4F46E5', colorGlow: 'rgba(79,70,229,0.18)', trend: '+12%', bar: 100 , trendColor: '#4F46E5' ,variant: 'indigo'},
    { label: 'Active',       value: activeCount,   icon: UserCheck,  color: '#06B6D4', colorGlow: 'rgba(6,182,212,0.15)',  trend: '+8%',  bar: Math.round(activeCount/users.length*100), trendColor: '#06B6D4', variant: 'cyan' },
    { label: 'Inactive',     value: inactiveCount, icon: UserX,      color: ' #EF4444', colorGlow: 'rgba(239,68,68,0.15)',  trend: '-2%',  bar: Math.round(inactiveCount/users.length*100), trendDir: 'down', trendColor: '#EF4444',variant: 'red'  },
    { label: 'Pending',      value: pendingCount,  icon: Clock,      color: '#F59E0B', colorGlow: 'rgba(245,158,11,0.15)',  trend: '0%',   bar: Math.round(pendingCount/users.length*100),  trendDir: 'neutral', trendColor: '#F59E0B' ,variant: 'amber' },
  ]

  return (
    <div className="dash-page page-in">
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:'var(--space-md)' }}>
        <h1 className="page-title">Users</h1>
        <button className="btn btn-primary" onClick={openAdd}><Plus size={14}/> Add User</button>
      </div>

      <div className="stats-grid cols-4">
        {stats.map(s => (
          <div key={s.label} className={`stat-card stat-card--${s.variant}`} >
            <span style={{"position": "absolute", "top": "0px", "right": "0px", "width": "110px", "height": "110px", "border-radius": "50%", "background": s.colorGlow  , "filter": "blur(30px)", "transform": "translate(30%, -30%)", "pointer-events": "none"}}></span>
            <div className="stat-card-header">
              <div className="stat-card-icon" style={{ background: s.colorGlow, color: s.color, border: `1px solid ${s.colorGlow}` }}>
                <s.icon size={15} strokeWidth={1.8}/>
              </div>
              <span className={`stat-card-trend${s.trendDir === 'down' ? ' down' : s.trendDir === 'neutral' ? ' neutral' : ''}`} style={{ color: s.trendColor, background: `${s.trendColor}15`, border: `1px solid ${s.colorGlow}` }}>
                {s.trend}
              </span>
            </div>
            <div className="stat-card-value">{s.value}</div>
            <div className="stat-card-label">{s.label}</div>
            <div style={{ "position": "absolute", "bottom": "0px", "left": "0px", "right": "0px", "height": "2px", background: `linear-gradient(90deg,${s.color}88,transparent)`, "border-radius": "0 0 var(--radius-lg) var(--radius-lg)" }}></div>
          </div>
        ))}
      </div>

      <div className="card" style={{ padding:0 }}>
        <div style={{ display:'flex', alignItems:'center', gap:'var(--space-sm)', padding:'var(--space-md) var(--space-lg)', borderBottom:'1px solid var(--border)', flexWrap:'wrap' }}>
          <div style={{ position:'relative', flex:1, minWidth:200 }}>
            <Search size={13} style={{ position:'absolute', left:10, top:'50%', transform:'translateY(-50%)', color:'var(--text3)' }}/>
            <input className="input" style={{ paddingLeft:32 }} placeholder="Search users…" value={search} onChange={e => setSearch(e.target.value)}/>
          </div>
          <button className="btn btn-outline btn-sm">Filter</button>
          <button className="btn btn-outline btn-sm">Export</button>
        </div>

        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr><th>User</th><th>Role</th><th>Plan</th><th>Status</th><th>Joined</th><th></th></tr>
            </thead>
            <tbody>
              {filtered.map(u => (
                <tr key={u.id}>
                  <td>
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                      <div style={{ width:32, height:32, borderRadius:'50%', background:'var(--bg-active)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:'var(--fs-xs)', fontWeight:700, color:'var(--accent-hover)', flexShrink:0 }}>
                        {u.name.split(' ').map(n => n[0]).join('')}
                      </div>
                      <div>
                        <div style={{ fontWeight:600, color:'var(--text1)', fontSize:'var(--fs-sm)' }}>{u.name}</div>
                        <div style={{ fontSize:'var(--fs-xs)', color:'var(--text3)' }}>{u.email}</div>
                      </div>
                    </div>
                  </td>
                  <td>{u.role}</td>
                  <td><span className="badge badge-gold">{u.plan}</span></td>
                  <td><span className={`badge ${u.status==='active'?'badge-active':u.status==='inactive'?'badge-inactive':'badge-pending'}`}>{u.status}</span></td>
                  <td style={{ color:'var(--text3)', fontSize:'var(--fs-xs)' }}>{u.joined}</td>
                  <td>
                    <div style={{ display:'flex', gap:6 }}>
                      <button className="btn btn-ghost btn-icon" onClick={() => openEdit(u)} aria-label="Edit"><Pencil size={14}/></button>
                      <button className="btn btn-ghost btn-icon" onClick={() => { setActive(u); setDeleteOpen(true) }} aria-label="Delete"><Trash2 size={14}/></button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      <Modal
        open={modalOpen}
        title={active ? 'Edit User' : 'Add User'}
        subtitle="Create or update user account details"
        onClose={() => setModalOpen(false)}
        footer={(
          <>
            <button className="btn btn-outline" onClick={() => setModalOpen(false)}>Cancel</button>
            <button className="btn btn-primary" onClick={saveUser}>{active ? 'Update User' : 'Create User'}</button>
          </>
        )}
      >
        <div className="form-grid cols-2">
          <div className="form-field">
            <label>Full Name</label>
            <input className="input" placeholder="Enter full name" value={form.name} onChange={e => setForm({...form, name:e.target.value})}/>
          </div>
          <div className="form-field">
            <label>Email Address</label>
            <input className="input" placeholder="Enter email address" value={form.email} onChange={e => setForm({...form, email:e.target.value})}/>
          </div>
          <div className="form-field">
            <label>Role</label>
            <select className="input" value={form.role} onChange={e => setForm({...form, role:e.target.value})}>
              <option>User</option><option>Manager</option><option>Admin</option>
            </select>
          </div>
          <div className="form-field">
            <label>Plan</label>
            <select className="input" value={form.plan} onChange={e => setForm({...form, plan:e.target.value})}>
              <option>Free</option><option>Starter</option><option>Pro</option><option>Enterprise</option>
            </select>
          </div>
          <div className="form-field full">
            <label>Status</label>
            <select className="input" value={form.status} onChange={e => setForm({...form, status:e.target.value})}>
              <option value="active">active</option>
              <option value="inactive">inactive</option>
              <option value="pending">pending</option>
            </select>
          </div>
        </div>
      </Modal>

      <ConfirmModal
        open={deleteOpen}
        title="Delete user"
        message={`Remove ${active?.name || 'this user'} from the system?`}
        onClose={() => setDeleteOpen(false)}
        onConfirm={confirmDelete}
      />

      <style>{`.dash-page{display:flex;flex-direction:column;gap:var(--space-lg);width:100%;}`}</style>
    </div>
  )
}